import { render } from "./pos-modal.vue?vue&type=template&id=698d51af"
import script from "./pos-modal.vue?vue&type=script&lang=js"
export * from "./pos-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__